"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const env_1 = __importDefault(require("../env"));
const random_1 = __importDefault(require("../number/random"));
const API_1 = __importDefault(require("./API"));
class Catalyst extends API_1.default {
    constructor() {
        super(...arguments);
        this.available = null;
    }
    /**
     * TODO(#323): remove on v6
     * @deprecated use getInstance instead
     */
    static get() {
        return this.getInstance();
    }
    static getInstance() {
        return this.getInstanceFrom((0, env_1.default)('PROFILE_URL', this.Url));
    }
    /**
     * TODO(#323): remove on v6
     * @deprecated use getAnyInstance instead
     */
    static getAny() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getAnyInstance();
        });
    }
    static getAnyInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.Servers) {
                this.Servers = this.get()
                    .getServers()
                    .then((servers) => {
                    for (const server of servers) {
                        this.Cache.set(server.baseUrl, new Catalyst(server.baseUrl));
                    }
                });
            }
            yield this.Servers;
            while (this.Cache.size) {
                const instances = Array.from(this.Cache.values());
                const index = (0, random_1.default)(instances.length);
                if (instances[index]) {
                    const instance = instances[index];
                    if (instance.available) {
                        return instance;
                    }
                    const result = yield API_1.default.catch(instance.getStatus());
                    if (result) {
                        instance.available = true;
                        return instance;
                    }
                    this.Cache.delete(instance.baseUrl);
                }
            }
            return this.getInstance();
        });
    }
    /**
     * TODO(#323): remove on v6
     * @deprecated use getInstanceFrom instead
     */
    static from(baseUrl) {
        return this.getInstanceFrom(baseUrl);
    }
    static getInstanceFrom(baseUrl) {
        if (!this.Cache.has(baseUrl)) {
            this.Cache.set(baseUrl, new Catalyst(baseUrl));
        }
        return this.Cache.get(baseUrl);
    }
    getProfile(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetch(`/lambdas/profile/${address.toLowerCase()}`);
            return (result && result.avatars && result.avatars[0]) || null;
        });
    }
    /**
     * loads profile data in parallel
     *
     * @param addresses - profile addresses list
     * @returns array of profiles in the same order used in the addresses param,
     *  if the profile doesn't exists the array will include a `null` in the corresponding
     *  position
     *
     * @example
     * ```typescript
     * getProfiles([ `0x1234...`, 0x00000 ]) => Promise<[ { user: `0x1234...`, ...profile }, null ]>
     * ```
     */
    getProfiles(addresses) {
        return __awaiter(this, void 0, void 0, function* () {
            if (addresses.length === 0) {
                return [];
            }
            const params = new URLSearchParams();
            for (const address of addresses) {
                params.append('id', address.toLowerCase());
            }
            const results = yield this.fetch(`/lambdas/profiles/?` + params.toString());
            const map = new Map(results
                .filter((result) => {
                const avatar = result.avatars[0];
                if (!avatar.ethAddress) {
                    (0, rollbar_1.default)((logger) => logger.error(`Error loading profiles`, {
                        avatar,
                        addresses,
                        server: this.baseUrl,
                    }));
                    (0, segment_1.default)((analytics) => analytics.track('error', {
                        message: `Error loading profiles`,
                        server: this.baseUrl,
                        addresses,
                        avatar,
                    }));
                    return false;
                }
                return true;
            })
                .map((result) => {
                const avatar = result.avatars[0];
                return [avatar.ethAddress.toLowerCase(), avatar];
            }));
            return addresses.map((address) => map.get(address.toLowerCase()) || null);
        });
    }
    getStatus(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getCommsStatus(options);
        });
    }
    getCommsStatus(_options) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    getAbout() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/about');
        });
    }
    /** @deprecated use `getAbout` instead*/
    getCommsAbout() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/about');
        });
    }
    getLambdasStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/lambdas/status');
        });
    }
    getContentStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/content/status');
        });
    }
    getContentUrl(hash) {
        return this.url(`/content/contents/${hash}`);
    }
    getContentEntity(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/content/contents/${hash}`);
        });
    }
    getEntityScenes(pointers) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!pointers || pointers.length === 0) {
                return [];
            }
            const params = pointers
                .map((point) => {
                return ('pointer=' +
                    (Array.isArray(point) ? point.slice(0, 2).join(',') : point));
            })
                .join('&');
            return this.fetch('/content/entities/scene?' + params);
        });
    }
    getRealms() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/lambdas/explore/realms');
        });
    }
    getHostScenes() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/lambdas/explore/hot-scenes');
        });
    }
    getServers() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/lambdas/contracts/servers`);
        });
    }
    getPOIs() {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield this.fetch(`/lambdas/contracts/pois`);
            const pois = [];
            for (const result of results) {
                const [x, y] = String(result || '')
                    .split(',')
                    .map(Number);
                if (Number.isFinite(x) && Number.isFinite(y)) {
                    pois.push([x, y]);
                }
            }
            return pois;
        });
    }
    getBanNames() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/lambdas/contracts/denylisted-names`);
        });
    }
    /**
     * @deprecated by the archipelago update
     * @see https://decentraland.org/blog/project-updates/communication-protocol-improvements/
     * @see https://github.com/decentraland/adr/blob/main/docs/ADR-35-coms-protocol-optimizations.md
     */
    getLayers() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/comms/layers');
        });
    }
    /**
     * @deprecated by the archipelago update
     * @see https://decentraland.org/blog/project-updates/communication-protocol-improvements/
     * @see https://github.com/decentraland/adr/blob/main/docs/ADR-35-coms-protocol-optimizations.md
     */
    getLayerUsers(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/comms/layers/${layer}/users`);
        });
    }
    getPeers() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetch(`/comms/peers`);
            return result.peers;
        });
    }
    getContentDeployments(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { entityIds, entityTypes } = options, data = __rest(options, ["entityIds", "entityTypes"]);
            const params = API_1.default.searchParams(data, { dataToTimestamp: true });
            if (Array.isArray(entityIds)) {
                for (const entityId of entityIds) {
                    params.append('entityId', entityId);
                }
            }
            if (Array.isArray(entityTypes)) {
                for (const entityType of entityTypes) {
                    params.append('entityType', entityType);
                }
            }
            const query = params.toString();
            return this.fetch('/content/deployments' + (query ? '?' : '') + query);
        });
    }
    getStatsParcels() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('/stats/parcels');
        });
    }
    verifySignature(authChain, message) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/lambdas/crypto/validate-signature`, this.options().method('POST').json({ authChain, timestamp: message }));
        });
    }
}
exports.default = Catalyst;
Catalyst.Url = (0, env_1.default)('CATALYST_API', '') || // @deprecated
    (0, env_1.default)('PROFILE_URL', 'https://peer.decentraland.org');
Catalyst.Servers = null;
Catalyst.Cache = new Map();
